( () => {

	/**
	 * Block name
	 *
	 * @type {string}
	 */
	const blockName = 'photos-hero-intro';

	/**
	 * Init
	 */
	window.addEventListener( 'load', () => {

		const blocks = document.querySelectorAll( `.block-${ blockName }` );
		if ( blocks.length > 0 ) {

			blocks.forEach( ( block ) => {

				initializeBlock( block );

			} );

		}

	} );

	/**
	 * Block init
	 *
	 * @param {Object} block
	 */
	const animateOnScroll = ( block ) => {

		const images = block.querySelectorAll( '.hero-image' );
		const text = block.querySelector( '.content-wrapper' );
		const scrollData = {
			stickyStart: 0,
			stickyEnd: 600,
			animationStart: 100,
		};

		/**
		 * Add animation on scroll
		 *
		 */
		const onScroll = () => {

			const scroollScene = block.querySelector(
				'.block-photos-hero-intro__scroll-scene'
			);
			const blockInner = block.querySelector(
				'.block-photos-hero-intro__inner'
			);

			// when header is visible
			if ( window.scrollY <= block.offsetTop + scrollData.stickyStart ) {

				if ( scroollScene ) {

					scroollScene.classList.remove( 'scroll-scene-fixed' );
					blockInner.setAttribute( 'style', 'padding-top: 0' );

				}

			}

			// when scroll block to scrollData.stickyStart position - stick block
			if (
				window.scrollY > block.offsetTop + scrollData.stickyStart &&
				window.scrollY < block.offsetTop + scrollData.stickyEnd
			) {

				if ( scroollScene ) {

					let screenWidth = block.offsetWidth;
					if ( block.offsetWidth > 1600 ) {

						screenWidth = 1600; // max container width

					}

					scroollScene.classList.add( 'scroll-scene-fixed' );
					scroollScene.setAttribute(
						'style',
						`top: -${
							scrollData.stickyStart
						}px; max-width: ${ screenWidth - 80 }px;`
					);
					blockInner.setAttribute( 'style', 'padding-top: 0' );

				}

			}

			// when scroll block to scrollData.stickyEnd position - unstick block
			if ( window.scrollY >= block.offsetTop + scrollData.stickyEnd ) {

				if ( scroollScene ) {

					scroollScene.classList.remove( 'scroll-scene-fixed' );
					blockInner.setAttribute(
						'style',
						`padding-top: ${ scrollData.stickyEnd -
							scrollData.stickyStart }px`
					);

				}

			}

			// when to start animations
			if (
				window.scrollY >
				block.offsetTop + scrollData.animationStart
			) {

				if ( images.length > 0 ) {

					images.forEach( ( image ) => {

						image.classList.add( 'hero-image--animated' );

					} );

				}

				if ( text ) {

					text.classList.add( 'content-wrapper--hidden' );

				}

			} else {

				if ( images.length > 0 ) {

					images.forEach( ( image ) => {

						image.classList.remove( 'hero-image--animated' );

					} );

				}

				if ( text ) {

					text.classList.remove( 'content-wrapper--hidden' );

				}

			}

		};

		// add scroll event listener only if block is visible on screen
		const observer = new IntersectionObserver( ( entries ) => {

			entries.forEach( ( entry ) => {

				if ( entry.isIntersecting ) {

					window.addEventListener( 'scroll', onScroll, {
						passive: true,
					} );

				} else {

					window.removeEventListener( 'scroll', onScroll, {
						passive: true,
					} );

				}

			} );

		} );

		observer.observe( block );

	};

	/**
	 * Block init
	 *
	 * @param {Object} block
	 */
	const initializeBlock = ( block ) => {

		if ( block[ 0 ] !== undefined ) {

			block = block[ 0 ].querySelector( `.block-${ blockName }` );

		}
		if ( block === false || block === null ) {
		}

		// Block Code Here
		animateOnScroll( block );

	};

} )();
